// ISM (DVBW_YogeshEN) to Unicode Converter
// Exact copy of the original DVBW_YogeshEN_to_Unicode function

export function convert_ism_to_unicode(inputText) {
    if (!inputText || inputText.trim() === '') {
        return '';
    }

    // Exact arrays from your original function
    const array_one = [
        "‚","ƒ","„","…","±ÎÌ","±ÏÌ",
        "†Öò","Öò",
        "†Öê","†Öî","†Ö","†","‡Ô","‡","‰","ˆ","Š","‹ê","‹","†ÖêÓ","†ÖîÓ",

        "ŒÌ","Œ","Ì","Û","","Î", "","Ì","Ü","","Ì","Ý","","Î","'","'",

        "\u201C","\u201D","•Ì","•","–","—","˜",

        "™","š","›","œ","Þ","",

        "Ÿ","¡","¢","£","¤","¥","¦","§","¨","©","ª","«","­","®",
        "¬",

        "¯","°Ì","±Ì","°","±","²","³","´",

        "µ","•","¸","¹","º","»","ó","ô","¾",

        "¿","À","Á","Â","Ã",

        "¼","½",

        "Ä","Å","Æ","Ç","È","É","Ê",

        "Ë","Ì","Í","Î","Ï",

        "Ð","Ñ","Ò","Ó",

        "÷","ø","ù","ú","û","ü","ý","þ",
        "Öê","Öî","ê","î","Ö","्ा","ß","ã","å","æ","è","é","ë","ï","ò",
        "ú","û","ü","ý","þ",
        "आे","¬","्ो","्ौ"
    ];

    const array_two = [
        "ॐ","ऽ","ः","।","फ़्र","फ़्र",
        "ऑ","ॉ",
        "ओ","औ","आ","अ","ई","इ","ऊ","उ","ऋ","ऐ","ए","ओं","औं",

        "क़्","क्","क़","क","क","क्र","क्ष्","ख़्","ख्","ख्","ग़्","ग्","ग्","ग्र्","घ्","ङ",

        "च्","छ","ज़्","ज्","ज्ञ्","झ्","ञ्",

        "ट","ठ","ड","ढ","ण्","ण्",

        "त्","त्र्","त्त्","थ्","द","दृ","द्र","द्द","द्ध","द्म","द्य","द्व","न्","न्न्",
        "ध्",

        "प्","फ़्","फ़","फ्","फ","ब्","भ्","म्",

        "य्","्य","र","रु","रू","ल्","ळ्","ळ","व्",

        "श्","श्","श्र्","ष्","स्",

        "ट्ट","ट्ठ",

        "रु","ह्","ह","हृ","ह्र","ह्म","ह्य",

        "्","़","़","्र","्र",

        "्र","ँ","्र","ं",

        "ट्ठ","ड्ड","ड्ढ","","","","","",

        "ो","ौ","े","ै","ा","","ी","ु","ु","ू","ू","ृ","ें","ैं","ॅ",
        "","","","","",
        "ओ","ध्","े","ौ"
    ];

    const array_one_length = array_one.length;
    let modified_substring = inputText;

    function Replace_Symbols() {
        if (modified_substring !== "") {
            // Substitute array_two elements in place of corresponding array_one elements
            for (let input_symbol_idx = 0; input_symbol_idx < array_one_length; input_symbol_idx++) {
                // Skip empty strings to avoid infinite loops
                if (array_one[input_symbol_idx] && array_one[input_symbol_idx] !== "") {
                    let idx = 0;
                    while (idx !== -1) {
                        modified_substring = modified_substring.replace(array_one[input_symbol_idx], array_two[input_symbol_idx]);
                        idx = modified_substring.indexOf(array_one[input_symbol_idx]);
                    }
                }
            }

            // Code for Replacing Special glyphs (from your original function)
            modified_substring = modified_substring.replace(/Õ/g, "Ôं");
            modified_substring = modified_substring.replace(/Öí/g, "ोंÔ");
            modified_substring = modified_substring.replace(/í/g, "Ôें");
            modified_substring = modified_substring.replace(/ì/g, "Ôे");
            modified_substring = modified_substring.replace(/ñ/g, "Ôैं");
            modified_substring = modified_substring.replace(/ð/g, "Ôै");
            modified_substring = modified_substring.replace(/á/g, "Ôी");
            modified_substring = modified_substring.replace(/à/g, "ीं");
            modified_substring = modified_substring.replace(/â/g, "Ôीं");
            modified_substring = modified_substring.replace(/Ù/g, "र्×");

            let position_of_i = modified_substring.indexOf("×");
            while (position_of_i !== -1) {
                const character_next_to_i = modified_substring.charAt(position_of_i + 1);
                const character_to_be_replaced = "×" + character_next_to_i;
                modified_substring = modified_substring.replace(character_to_be_replaced, character_next_to_i + "ि");
                position_of_i = modified_substring.search(/×/, position_of_i + 1);
            }

            modified_substring = modified_substring.replace(/Ú/g, "र्Ø");
            modified_substring = modified_substring.replace(/Ø/g, "×Ó");

            position_of_i = modified_substring.indexOf("×Ó");
            while (position_of_i !== -1) {
                const character_next_to_ip2 = modified_substring.charAt(position_of_i + 2);
                const character_to_be_replaced = "×Ó" + character_next_to_ip2;
                modified_substring = modified_substring.replace(character_to_be_replaced, character_next_to_ip2 + "िं");
                position_of_i = modified_substring.search(/×Ó/, position_of_i + 2);
            }

            // Fix wrong ि positioning on half-letters
            let position_of_wrong_ee = modified_substring.indexOf("ि्");
            while (position_of_wrong_ee !== -1) {
                const consonant_next_to_wrong_ee = modified_substring.charAt(position_of_wrong_ee + 2);
                const character_to_be_replaced = "ि्" + consonant_next_to_wrong_ee;
                modified_substring = modified_substring.replace(character_to_be_replaced, "्" + consonant_next_to_wrong_ee + "ि");
                position_of_wrong_ee = modified_substring.search(/ि्/, position_of_wrong_ee + 2);
            }

            // Handle reph "Ô" positioning
            const set_of_matras = "ा ि ी ु ू ृ े ै ो ौ ं : ँ ॅ";
            let position_of_R = modified_substring.indexOf("Ô");

            while (position_of_R > 0) {
                let probable_position_of_half_r = position_of_R - 1;
                let character_at_probable_position_of_half_r = modified_substring.charAt(probable_position_of_half_r);

                while (set_of_matras.match(character_at_probable_position_of_half_r) !== null) {
                    probable_position_of_half_r = probable_position_of_half_r - 1;
                    character_at_probable_position_of_half_r = modified_substring.charAt(probable_position_of_half_r);
                }

                const character_to_be_replaced = modified_substring.substr(probable_position_of_half_r, (position_of_R - probable_position_of_half_r));
                const new_replacement_string = "र्" + character_to_be_replaced;
                const full_character_to_be_replaced = character_to_be_replaced + "Ô";
                modified_substring = modified_substring.replace(full_character_to_be_replaced, new_replacement_string);
                position_of_R = modified_substring.indexOf("Ô");
            }

        }

        // Final corrections (from your original function)
        modified_substring = modified_substring.replace(/ाे/g, "ो");
        modified_substring = modified_substring.replace(/ाै/g, "ौ");
    }

    Replace_Symbols();
    return modified_substring;
}
